import React, { useContext } from 'react'
import styled, { css } from 'styled-components'
import { string } from 'prop-types'
import { stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { borderColor, greyLight, greyDark } from 'styles/colors'
import { fontSizes, fontWeights, Capitalize } from 'styles/typography'
import { square } from 'styles/global'
import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import { Font, EngravingActions } from 'components/buy/Engraving/EngravingComponents'
import { media } from 'styles/media'
import Fitty from 'components/Fitty'

const Container = styled.div`
  width: 100%;
  padding: ${stripUnit(spacing.medium) * 1.25 + 'px'} 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid ${borderColor};
  flex-direction: column;

  &:last-child {
    border-bottom: 1px solid ${borderColor};
  }

  ${media.small`
    padding: ${spacing.large} 0;
    flex-direction: row;
  `};
`

const InfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;

  ${media.small`
    padding-right: ${spacing.medium};
  `};
`

const Main = styled.main`
  flex: 1;
`

const FigureWrap = styled.div`
  position: relative;
  border-radius: 50%;
  background-color: ${borderColor};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${spacing.medium};
  overflow: hidden;
  ${square('48px')}
`

const Figure = styled.img`
  position: absolute;
  object-fit: cover;
  top: -20%;
  left: 50%;
  width: 65%;
  transform: translateX(-50%);

  ${props =>
    props.icon &&
    css`
      top: 50%;
      width: 75%;
      transform: translateX(-50%) translateY(-50%);
    `}
`

const Name = styled.span`
  display: block;
  color: ${greyDark};
  font-weight: ${fontWeights.medium};
`

const Meta = styled.span`
  display: block;
  font-size: ${fontSizes.small};
  color: ${greyLight};
`

const Actions = styled.div`
  flex-shrink: 0;
  margin-top: ${spacing.medium};

  ${media.small`
    margin-top: 0;
  `};
`

const SummaryItem = ({ item }) => {
  const { engraving, skipItem, proceedItem } = useContext(EngravingContext)

  const stepFilled = Object.keys(engraving[item]).find(key => {
    if (key !== 'proceeded' && item !== 'proceeded') {
      return engraving[item][key].value.length > 0
    }
  })

  if (stepFilled)
    return (
      <Container className="summary-item">
        <InfoContainer>
          <FigureWrap>
            {item !== 'box' && (
              <>
                {stepFilled === 'pattern' && <Figure src={engraving[item][stepFilled].value} icon />}
                {stepFilled === 'miniIcon' && (
                  <Figure
                    src={`${process.env.BASE_PATH}/images/engraving/icons/thumbnails/${engraving[item][
                      stepFilled
                    ].name.toLowerCase()}.svg`}
                    icon
                  />
                )}
                {stepFilled === 'text' && (
                  <Fitty>
                    <Font font={engraving[item][stepFilled].font}>ABC</Font>
                  </Fitty>
                )}
              </>
            )}
          </FigureWrap>
          <Main>
            <Name>
              ePod <Capitalize>{item}</Capitalize>
            </Name>
            {stepFilled !== 'text' ? (
              <Meta>{`${engraving[item][stepFilled].displayName} - ${engraving[item][stepFilled].name}`}</Meta>
            ) : (
              <>
                {item !== 'box' ? (
                  <>
                    <Meta>{`Typeface - ${engraving[item][stepFilled].font}`}</Meta>
                    <Meta>{`Text Alignment - ${engraving[item][stepFilled].orientation}`}</Meta>
                    <Meta>{`Message - ${engraving[item][stepFilled].value}`}</Meta>
                  </>
                ) : (
                  <Meta>{`First Name - ${engraving[item][stepFilled].value}`}</Meta>
                )}
              </>
            )}
          </Main>
        </InfoContainer>
        <Actions>
          <EngravingActions
            onRemove={() => {
              skipItem(item)
            }}
            onEdit={() => {
              proceedItem(item, null, false)
            }}
          />
        </Actions>
      </Container>
    )

  return null
}

SummaryItem.propTypes = {
  item: string
}

export default SummaryItem
